module.exports = __webpack_public_path__ + "img/travel3.cdd8732a.jpg";